<template>
  <b-table class="sticky-table-header" :data="bags" narrowed hoverable>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="name"
      :label="$t('bags.name')"
      sortable
      v-slot="props"
    >
      {{ props.row.name }}
    </b-table-column>

    <b-table-column
      field="email"
      :label="$t('bags.prdQty')"
      sortable
      v-slot="props"
    >
      {{ props.row.prdQty }}
    </b-table-column>

    <b-table-column :label="$t('bags.actions')" v-slot="props" centered>
      <b-tooltip :label="$t('bags.editButton')" position="is-left" multilined>
        <button class="button is-small" @click="editBag(props.row)">
          <b-icon icon="edit" type="is-dark"></b-icon>
        </button>
      </b-tooltip>

      <b-tooltip :label="$t('bags.showQRCode')" position="is-left" multilined>
        <button
          class="button is-small ml-4"
          @click="qrcodeClick(props.row.uuid)"
        >
          <b-icon icon="qrcode" type="is-dark"></b-icon>
        </button>
      </b-tooltip>

      <b-tooltip
        :label="$t('bags.removeToolTip')"
        position="is-left"
        multilined
      >
        <button
          class="button is-small ml-4"
          @click="deleteBagClick(props.row)"
          v-if="permissions.canManageBag"
        >
          <b-icon icon="trash" type="is-primary"></b-icon>
        </button>
      </b-tooltip>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";

export default {
  props: ["bags"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    editBag(bag) {
      this.$emit("edit-bag", bag);
    },

    qrcodeClick(bagUUID) {
      this.$emit("qrcode-click", bagUUID);
    },

    deleteBagClick(bag) {
      this.$emit("delete-bag", bag);
    }
  },
  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>
